<div class="reorder-dialog">
  <div class="reorder-header">
    <h2>{{ 'global.reorder_skills_title' | translate }}</h2>
    <p>{{ 'global.reorder_skills_subtitle' | translate }}</p>
  </div>

  <div class="reorder-list" cdkDropList (cdkDropListDropped)="drop($event)">
    <div class="reorder-item" *ngFor="let skill of skills; let i = index" cdkDrag>
      <span class="drag-handle" cdkDragHandle aria-hidden="true">
        <img src="/assets/icons/sort-icon.svg" alt="" />
      </span>
      <span class="skill-order">{{ i + 1 }}.</span>
      <span class="skill-name">{{ skill.skill_name }}</span>
    </div>
  </div>

  <div class="reorder-actions">
    <button type="button" class="btn w-lg h-lg" (click)="cancel()">
      {{ 'global.cancel' | translate }}
    </button>
    <button type="button" class="btn w-lg h-lg secondary" (click)="save()">
      {{ 'global.save' | translate }}
    </button>
  </div>
</div>
